module.exports = __webpack_public_path__ + "img/img3.3c1afb9f.png";